<template>
  <div id="AppRegularDisposablesOrder">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div
      class="columns"
      style="margin-left: 50px; margin-Right: 50px;"
    >
      <div class="column is-full">
        <label class="searchTitle label">消耗品発送登録</label>
      </div>
    </div>
    <!-- 詳細表示 -->
    <div
      class="columns"
      style="margin-left: 50px; margin-Right: 50px;"
    >
      <div class="column is-full detailArea">
        <div class="notice is-6">
          <span style="font-weight: bold">
            患者コード：{{patient}}
            <br />
            患者名：{{patientNam}}
          </span>
        </div>
        <div>
          <table
            v-for="(props,subscript) in productDispoables"
            v-bind:key="subscript"
            class="is-full"
          >
            <tr>
              <td
                style="padding-top: 10px; padding-bottom: 10px; border-bottom: solid 1px;"
                colspan="2"
              >
                <div class="notice title is-6">
                  {{props.productName}}
                  <br />
                  ({{props.serialNumber}})
                  <br />
                  {{props.inspectionKind | inspectionTypeFillter}}
                </div>
              </td>
            </tr>
            <tr>
              <td
                style="padding-top: 10px; border-bottom: solid 1px;width:7%;"
                :rowspan="props.length"
              >
                <div class="notice title is-6">消耗品</div>
                <b-button
                  v-if="props.disposables.length < 20"
                  style="float:left"
                  class="button is-primary has-text-centered"
                  icon-left="comment-plus-outline"
                  native-type="button"
                  v-on:click="addListPush(props)"
                  position="is-right"
                  :disabled="(!isSourceInspectionView && !activeFlag)||allDisableFlag || (!isSourceInspectionView && isNotAdd)"
                ></b-button>
              </td>
              <td
                v-if="isSourceInspectionView"
                style="padding-top: 15px; border-bottom: solid 1px;width:100%"
              >
                <table
                  v-for="(disposable,index) in props.disposables"
                  v-bind:key="index"
                >
                  <!-- 処方値修正画面、点検入力画面からの遷移 -->
                  <tr
                    style="width:100%"
                    class="is-full"
                    v-if="!disposable.deleteFlg"
                  >
                    <td style="font-size: 12pt; width:10%;">
                      <span>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index))"
                        >
                          <b-select
                            :readonly="notChangeFlag && disposable.deliveryKindFlag == 1"
                            v-model="disposable.deliveryKindFlag"
                            v-on:input="changeDeliveryKindFlag(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index),subscript,index,disposable.deliveryKindFlag)"
                          >
                            <option
                              value="1"
                              :disabled="notChangeFlag || !activeFlag"
                            >定期</option>
                            <option
                              value="9"
                              :disabled="notChangeFlag && disposable.deliveryKindFlag == 1"
                            >非定期</option>
                          </b-select>
                          <!-- :disabled="isDeliveryActive || roleId==2" -->
                          <span>
                            <input
                              :name="getFieldName('regularDeliveryFlag',props.productName,props.serialNumber,index)"
                              :id="getFieldName('regularDeliveryFlag',props.productName,props.serialNumber,index)"
                              type="checkbox"
                              style="margin-top:10px; margin-left:5px; width:30px; transform:	scale(1.4);"
                              v-model="disposable.regularDeliveryFlag"
                              :disabled="(!activeFlag || notChangeFlag) && disposable.deliveryKindFlag == 1"
                              v-validate="`checkInterval:${disposable.interval}`"
                            />発送
                          </span>
                        </b-field>
                      </span>
                    </td>
                    <td style="width:13%;">
                      <b-field>
                        <b-input
                          v-if="disposable.deliveryKindFlag == 1"
                          :name="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          :id="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          data-vv-as="数量が1以上の場合、消耗品コード"
                          :data="filteredProduct"
                          v-model="disposable.itemCode"
                          field="itemCode"
                          :readOnly="notChangeFlag || !activeFlag"
                          v-validate="`${disposable.count && disposable.count !=0 ? 'required' : ''}|checkDisposable|checkDuplication:${props.productCode},${props.serialNumber}`"
                          @select="option => {disposable.itemCode = option.productCode;
                          errors.remove(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                          v-on:blur="disposableFilter(disposable, disposablesMaster)"
                        ></b-input>
                        <b-input
                          v-else
                          :name="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          :id="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          data-vv-as="消耗品コード"
                          :data="filteredProduct"
                          v-model="disposable.itemCode"
                          field="itemCode"
                          :readOnly="isProductCodeActive || roleId==2"
                          v-validate="`${disposable.count && disposable.count !=0 ? 'required' : ''}|checkProduct|checkDuplication:${props.productCode},${props.serialNumber}`"
                          @select="option => {disposable.itemCode = option.productCode;
                          errors.remove(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                          v-on:blur="disposableFilter(disposable, productMaster)"
                        ></b-input>
                        <b-button
                          :disabled="(notChangeFlag || !activeFlag) && disposable.deliveryKindFlag == 1"
                          style="float:right"
                          class="button is-primary has-text-centered"
                          native-type="button"
                          id="index"
                          v-on:click="changeProduct(props.productCode,props.productName,props.serialNumber,index,disposable.deliveryKindFlag)"
                        >検索</b-button>
                      </b-field>
                    </td>
                    <td style="width:18%;font-size: 10pt;">
                      <b-field
                        :type="{'is-danger': errors.has(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                        :message="errors.first(getFieldName('itemCode',props.productName,props.serialNumber,index))"
                      ></b-field>
                      {{ disposable.name }}
                    </td>
                    <td style="width:10%;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('preDate',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('preDate',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-if="disposable.deliveryKindFlag == 1"
                            style="width:95%;"
                            v-model="disposable.preDateSt"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            :readonly="true"
                          ></b-input>
                          <b-datepicker
                            v-else-if="!notChangeFlag || (notChangeFlag && disposable.deliveryKindFlag == 9)"
                            style="width:95%;"
                            v-model="disposable.preDate"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            data-vv-validate-on="input"
                            v-validate="`${disposable.itemCode != null && disposable.count !=0 ? 'required' : ''}`"
                            :input="setNextDate(disposable)"
                            :date-formatter="formatDate2"
                            :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                            :day-names="['日','月','火','水','木','金','土']"
                          >
                            <button
                              class="button is-danger"
                              @click="setDateNull(disposable)"
                            >
                              <b-icon icon="close"></b-icon>
                              <span>Clear</span>
                            </button>
                          </b-datepicker>
                          <b-input
                            v-else
                            style="width:95%;"
                            :value="formatDate2(disposable.preDate)"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            :input="setNextDate(disposable)"
                            :readonly="true"
                          ></b-input>
                          <span style="margin-left:5px;"></span>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%;padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('interval',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('interval',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-if="disposable.deliveryKindFlag == 1"
                            :name="getFieldName('interval',props.productName,props.serialNumber,index)"
                            :id="getFieldName('interval',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="発送期間"
                            type="number"
                            min="0"
                            max="999"
                            readonly
                            v-model="disposable.interval"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:999`"
                          ></b-input>
                          <b-input
                            v-else
                            :name="getFieldName('interval',props.productName,props.serialNumber,index)"
                            :id="getFieldName('interval',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="発送期間"
                            type="number"
                            min="0"
                            max="999"
                            v-model="disposable.interval"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:999`"
                          ></b-input>
                          <span style="margin-left:2px;">ヶ月</span>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%;padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('count',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('count',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            :name="getFieldName('count',props.productName,props.serialNumber,index)"
                            :id="getFieldName('count',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="消耗品個数"
                            type="number"
                            min="0"
                            max="999"
                            :readonly="(notChangeFlag || !activeFlag) && disposable.deliveryKindFlag == 1"
                            v-model="disposable.count"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:999`"
                          ></b-input>
                          <span style="margin-left:2px;">EA</span>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:10%; padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('nextDate',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('nextDate',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-model="disposable.nextDate"
                            :name="getFieldName('nextDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('nextDate',props.productName,props.serialNumber,index)"
                            data-vv-as="次回供給予定日"
                            placeholder="次回供給予定日"
                            icon="calendar-today"
                            :readonly="true"
                            data-vv-validate-on="change"
                            v-validate="`checkNextDate:${subscript},${index}|checkConfirmedDate:${subscript},${index}|checkNextInspection:${disposable.deliveryKindFlag}, ${disposable.nextDate}, ${disposable.itemCode}`"
                          ></b-input>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%; padding-left: 5px;">
                      <!-- v-on:click="removeReportDest(data.extraReportDestination.destinations, index)" -->
                      <b-button
                        class="button is-primary has-text-centered"
                        icon-left="comment-remove-outline"
                        native-type="button"
                        v-on:click="deleteDisposable(props, index)"
                        position="is-right"
                        :disabled="notChangeFlag && disposable.deliveryKindFlag == 1"
                      ></b-button>
                    </td>
                  </tr>
                </table>
              </td>
              <td
                v-else
                style="padding-top: 15px; border-bottom: solid 1px;width:100%"
              >
                <table
                  v-for="(disposable,index) in props.disposables"
                  v-bind:key="index"
                >
                  <!-- 定期消耗品発送検索画面からの遷移 -->
                  <tr
                    style="width:100%"
                    class="is-full"
                    v-if="!disposable.deleteFlg"
                  >
                    <td style="font-size: 12pt; width:20%;">
                      <span>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index))"
                        >
                          <b-select
                            v-model="disposable.deliveryKindFlag"
                            v-on:input="changeDeliveryKindFlag(getFieldName('deliveryKindFlag',props.productName,props.serialNumber,index),subscript,index,disposable.deliveryKindFlag)"
                          >
                            <option
                              value="1"
                              :disabled="!isCancelActive || !activeFlag || !props.isInspectionMonth"
                            >定期</option>
                            <option
                              value="9"
                              :disabled="!isCancelActive || !activeFlag"
                            >非定期</option>
                          </b-select>
                          <span>
                            <input
                              :name="getFieldName('regularDeliveryFlag',props.productName,props.serialNumber,index)"
                              :id="getFieldName('regularDeliveryFlag',props.productName,props.serialNumber,index)"
                              type="checkbox"
                              style="margin-top:10px; margin-left:5px; width:30px; transform:	scale(1.4);"
                              v-model="disposable.regularDeliveryFlag"
                              :disabled="isDeliveryActive || roleId==2"
                              v-validate="`checkInterval:${disposable.interval}`"
                            />発送
                          </span>
                          <!-- <span v-if="disposable.deliveryKindFlag == 1 && isCancelDisplay"> -->
                          <span>
                            <input
                              :name="getFieldName('cancelFlag',props.productName,props.serialNumber,index)"
                              :id="getFieldName('cancelFlag',props.productName,props.serialNumber,index)"
                              type="checkbox"
                              style="margin-top:10px; margin-left:5px; width:30px; transform:	scale(1.4);"
                              v-model="disposable.cancelFlag"
                              :disabled="isChancelDisabled(disposable) || roleId==2 || status==0 || !disposable.regularDeliveryFlag"
                            />キャンセル
                          </span>
                        </b-field>
                      </span>
                    </td>
                    <td style="width:13%;">
                      <b-field>
                        <b-input
                          v-if="disposable.deliveryKindFlag == 1"
                          :name="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          :id="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          data-vv-as="数量が1以上の場合、消耗品コード"
                          :data="filteredProduct"
                          v-model="disposable.itemCode"
                          field="itemCode"
                          :readOnly="isProductCodeActive || roleId==2"
                          v-validate="`${disposable.count && disposable.count !=0 ? 'required' : ''}|checkDisposable|checkDuplication:${props.productCode},${props.serialNumber}`"
                          @select="option => {disposable.itemCode = option.productCode;
                          errors.remove(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                          v-on:blur="disposableFilter(disposable, disposablesMaster)"
                        ></b-input>
                        <b-input
                          v-else
                          :name="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          :id="getFieldName('itemCode',props.productName,props.serialNumber,index)"
                          data-vv-as="消耗品コード"
                          :data="filteredProduct"
                          v-model="disposable.itemCode"
                          field="itemCode"
                          :readOnly="isProductCodeActive || roleId==2"
                          v-validate="`${disposable.count && disposable.count !=0 ? 'required' : ''}|checkProduct|checkDuplication:${props.productCode},${props.serialNumber}`"
                          @select="option => {disposable.itemCode = option.productCode;
                          errors.remove(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                          v-on:blur="disposableFilter(disposable, productMaster)"
                        ></b-input>
                        <b-button
                          :disabled="isProductCodeActive || roleId==2"
                          style="float:right"
                          class="button is-primary has-text-centered"
                          native-type="button"
                          id="index"
                          v-on:click="changeProduct(props.productCode,props.productName,props.serialNumber,index,disposable.deliveryKindFlag)"
                        >検索</b-button>
                      </b-field>
                    </td>
                    <td style="width:18%;font-size: 10pt;">
                      <b-field
                        :type="{'is-danger': errors.has(getFieldName('itemCode',props.productName,props.serialNumber,index))}"
                        :message="errors.first(getFieldName('itemCode',props.productName,props.serialNumber,index))"
                      ></b-field>
                      {{disposable.name }}
                    </td>
                    <td style="width:10%;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('preDate',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('preDate',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-if="disposable.deliveryKindFlag == 1 || roleId==2"
                            style="width:95%;"
                            v-model="disposable.preDateSt"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            :readonly="true"
                          ></b-input>
                          <b-input
                            v-else-if="(disposable.deliveryKindFlag == 9&&!activeFlag)"
                            style="width:95%;"
                            v-model="disposable.preDateSt"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :input="setNextDate(disposable)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            :readonly="true"
                          ></b-input>
                          <b-datepicker
                            v-else
                            style="width:95%;"
                            v-bind:value="disposable.preDate"
                            v-on:input="setInterval($event, disposable)"
                            :name="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('preDate',props.productName,props.serialNumber,index)"
                            data-vv-as="前回供給日"
                            placeholder="前回供給日"
                            icon="calendar-today"
                            :date-formatter="formatDate2"
                            :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                            :day-names="['日','月','火','水','木','金','土']"
                          >
                            <button
                              class="button is-danger"
                              @click="setDateNull(disposable)"
                            >
                              <b-icon icon="close"></b-icon>
                              <span>Clear</span>
                            </button>
                          </b-datepicker>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%;padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('interval',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('interval',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-if="disposable.deliveryKindFlag == 1"
                            :name="getFieldName('interval',props.productName,props.serialNumber,index)"
                            :id="getFieldName('interval',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="発送期間"
                            type="number"
                            min="0"
                            max="99"
                            :readonly="disposable.deliveryKindFlag == 1 || roleId==2"
                            v-model="disposable.interval"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:99`"
                          ></b-input>
                          <b-input
                            v-else
                            :name="getFieldName('interval',props.productName,props.serialNumber,index)"
                            :id="getFieldName('interval',props.productName,props.serialNumber,index)"
                            style="width:100%;margin-left:0px;"
                            data-vv-as="発送期間"
                            type="number"
                            min="0"
                            max="99"
                            :readonly="disposable.deliveryKindFlag == 1 || roleId==2||allDisableFlag||!activeFlag"
                            v-bind:value="disposable.interval"
                            v-on:input="setPreDate($event, disposable)"
                            v-validate="`numeric|max_value:99`"
                          ></b-input>
                          <span style="margin-left:2px;">ヶ月</span>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%;padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('count',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('count',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-if="disposable.deliveryKindFlag == 1"
                            :name="getFieldName('count',props.productName,props.serialNumber,index)"
                            :id="getFieldName('count',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="消耗品個数"
                            type="number"
                            min="0"
                            max="999"
                            :readOnly="roleId==2 || (disposable.deliveryKindFlag == 1 && isCountActive)"
                            v-model="disposable.count"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:999`"
                          ></b-input>
                          <b-input
                            v-else
                            :name="getFieldName('count',props.productName,props.serialNumber,index)"
                            :id="getFieldName('count',props.productName,props.serialNumber,index)"
                            style="width:100%;"
                            data-vv-as="消耗品個数"
                            type="number"
                            min="0"
                            max="999"
                            :readOnly="roleId==2 || isCountActive ||allDisableFlag"
                            v-model="disposable.count"
                            v-validate="`${disposable.itemCode ? 'required' : ''}|numeric|max_value:999`"
                          ></b-input>
                          <span style="margin-left:2px;">EA</span>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:10%; padding-left: 5px;">
                      <div>
                        <b-field
                          :type="{'is-danger': errors.has(getFieldName('nextDate',props.productName,props.serialNumber,index))}"
                          :message="errors.first(getFieldName('nextDate',props.productName,props.serialNumber,index))"
                        >
                          <b-input
                            v-model="disposable.nextDate"
                            :name="getFieldName('nextDate',props.productName,props.serialNumber,index)"
                            :id="getFieldName('nextDate',props.productName,props.serialNumber,index)"
                            data-vv-as="次回供給予定日"
                            placeholder="次回供給予定日"
                            icon="calendar-today"
                            :readonly="true"
                            data-vv-validate-on="change"
                          ></b-input>
                        </b-field>
                      </div>
                    </td>
                    <td style="width:5%; padding-left: 5px;">
                      <!-- v-on:click="removeReportDest(data.extraReportDestination.destinations, index)" -->
                      <b-button
                        class="button is-primary has-text-centered"
                        icon-left="comment-remove-outline"
                        native-type="button"
                        v-on:click="deleteDisposable(props, index)"
                        position="is-right"
                        :disabled="!isCancelActive||allDisableFlag"
                      ></b-button>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <b-modal
              :active.sync="isSelectProductActive"
              has-modal-card
            >
              <selectProduct-form
                v-bind:index="targetItem.index"
                v-bind:deliveryKindFlag="targetItem.deliveryKindFlag"
                v-on:set-Product="setProduct"
              ></selectProduct-form>
            </b-modal>
          </table>
          <tr
            v-if="!isSourceInspectionView"
            style="border-bottom: solid 1px;"
            class="column is-full"
          >
            <td>
              <div class="notice title is-6">指定納期</div>
            </td>
            <td style="padding-left:10px;">
              <b-field
                :type="{'is-danger': errors.has('designatedDeliveryDate')}"
                :message="errors.first('designatedDeliveryDate')"
              >
                <b-input
                  v-if="isDesignatedDeliveryDateActive || roleId==2"
                  v-model="designatedDeliveryDate"
                  name="designatedDeliveryDate"
                  id="designatedDeliveryDate1"
                  data-vv-as="指定納期"
                  placeholder="指定納期"
                  icon="calendar-today"
                  :readonly="true"
                ></b-input>
                <b-datepicker
                  v-else
                  v-model="designatedDeliveryDate"
                  :min-date="minDate"
                  :max-date="maxDate"
                  name="designatedDeliveryDate"
                  id="designatedDeliveryDate2"
                  data-vv-as="指定納期"
                  placeholder="指定納期"
                  icon="calendar-today"
                  :focused-date="minDate"
                  :date-formatter="formatDate2"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                ></b-datepicker>
              </b-field>
            </td>
          </tr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const dayjs = require('dayjs');

import selectProductTemplate from "./AppSelectProduct";
const selectProductform = {
  methods: {
    select: function () {
      var item = this.$refs.filteredProduct.getProduct();
      // 選択結果を画面に反映
      if (item) {
        this.$emit("set-Product", item);
        this.$parent.close();
      }
    },
  },
  components: {
    selectProduct: selectProductTemplate,
  },
  props: ["index", "deliveryKindFlag"],
  template: `
      <form action="">
        <div class="modal-card" style="width: 800px;">
         <header class="modal-card-head">
           <p class="modal-card-title" style="color: whitesmoke;">消耗品選択</p>
         </header>         
        　<section class="modal-card-body">
          　<selectProduct ref="filteredProduct" v-bind:deliveryKindFlag="deliveryKindFlag"/>
          </section>
          <footer class="modal-card-foot">
            <div class="column is-full" style="text-align:center;">
              <b-button
                v-on:click=$parent.close()
                class="button"
                type="is-primary"
                icon-left="keyboard-backspace"
                native-type="button"
                >戻る</b-button>
              <b-button
                v-on:click="select()"
                class="button"
                type="is-primary"
                icon-left="content-save"
                native-type="button"
                >選択</b-button>
            </div>
          </footer>
        </div>
      </form>
    `,
};
export default {
  name: "AppRegularDisposablesOrder",
  props: [
    "disposablesByDevice",
    "isSourceInspection",
    "patientCode",
    "patientName",
    "interval",
    "productName",
    "serialNumber",
    "roleId",
    "isSourcePrescription",
    "previousDate",
    "isActive",
    "inspectionFlg",
    "disabledFlag",
    "status",
    "searchDeliveryMonth",
  ],
  methods: {
    setProduct: function (item) {
      var changeTarget = this.productDispoables.find(
        (val) =>
          val.productCode == this.targetItem.productCode &&
          val.serialNumber == this.targetItem.serialNumber
      );
      changeTarget.disposables[this.targetItem.index].itemCode = item;
      changeTarget.disposables[this.targetItem.index].name =
        this.setProductName(
          changeTarget.disposables[this.targetItem.index].itemCode,
          this.productMaster
        );

      // エラーリセット
      this.errors.remove(
        this.getFieldName(
          "itemCode",
          this.targetItem.productName,
          this.targetItem.serialNumber,
          this.targetItem.index
        )
      );

      this.targetItem = {
        productCode: "",
        productName: "",
        serialNumber: "",
        index: null,
        deliveryKindFlag: null,
      };
    },
    changeProduct: function (
      productCode,
      productName,
      serialNumber,
      index,
      deliveryKindFlag
    ) {
      this.isSelectProductActive = true;
      this.targetItem.productCode = productCode;
      this.targetItem.productName = productName;
      this.targetItem.serialNumber = serialNumber;
      this.targetItem.index = index;
      this.targetItem.deliveryKindFlag = deliveryKindFlag;
    },
    isSuccessEnd: function () {
      return this.successEndFlg;
    },
    save: function (event) {
      var excuteApi = this.setRegularDisposablesListPOST;
      var successCallBack = this.setRegularDisposablesListPOSTSuccess;
      var errorCallBack = this.setRegularDisposablesListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setRegularDisposablesListPOST: function (client) {
      // 定期消耗品発送情報設定
      // パラメータ作成
      var prmObj = this.getItems();
      return client.apis.apiInspection.setRegularDisposablesListPOST({
        body: prmObj,
      });
    },
    setRegularDisposablesListPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.successEndFlg = true;
    },
    setRegularDisposablesListPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.successEndFlg = false;
    },
    checkItems: function () {
      // 項目のバリデーションチェック
      var isIllegalFlag = false;
      let deliveryKindList = [];
      let nextMonthList = [];
      let deliveryDate = this.formatDate2(new Date(this.productDispoables[0].disposables[0].nextDate));
      for (var item in this.productDispoables) {
        for (var index in this.productDispoables[item].disposables) {
          if (this.productDispoables[item].disposables[index].deleteFlg) {
            // 削除済みの行はチェック対象外
            continue;
          }
          var target = this.productDispoables[item].disposables[index];
          if (target.itemCode && target.deliveryKindFlag == null) {
            var fieldName = this.getFieldName(
              "deliveryKindFlag",
              this.productDispoables[item].productName,
              this.productDispoables[item].serialNumber,
              index
            );
            this.$validator.errors.add({
              field: fieldName,
              msg: "発送種別(定期/非定期)は必須項目です。",
            });
            isIllegalFlag = true;
          }

          if (!this.isSourceInspectionView){
            // 消耗品発送検索画面からの場合
            // 定期消耗品ありかつ、非定期消耗品ありかつ、次回発送月が異なる
            if (!deliveryKindList.includes(target.deliveryKindFlag)) {
              deliveryKindList.push(target.deliveryKindFlag);
            }
            let year = new Date(target.nextDate).getFullYear();
            let month = new Date(target.nextDate).getMonth();
            let nextMonth = year + month;
            if (target.itemCode && !nextMonthList.includes(nextMonth)) {
              nextMonthList.push(nextMonth);
            }
            if (deliveryKindList.length > 1 && nextMonthList.length > 1) {
              // エラーメッセージ表示
              this.showErrorMessage(
                "次回発送月は同じ月に設定してください。"
              );
              isIllegalFlag = true;
            }

            if (target.itemCode && target.regularDeliveryFlag) {
              if ( target.nextDate != deliveryDate) {
                this.$validator.errors.add({
                  field: "designatedDeliveryDate",
                  msg: "次回供給予定日が異なる消耗品があります。指定納期を設定してください。",
                });
                isIllegalFlag = true;
              }
            }
          }
        }
      }
      return isIllegalFlag;
    },
    getItems: function () {
      // 返却リスト or 登録用パラメータ 作成処理
      var returnItems;
      var deliveryDate;
      if (this.designatedDeliveryDate) {
        deliveryDate = this.formatDate2(new Date(this.designatedDeliveryDate));
      } else if (this.$props.isSourcePrescription) {
        // 処方値の場合
        deliveryDate = this.formatDate2(
          this.getNextDate(
            this.parseDate(this.$props.previousDate),
            this.intervalMonth
          )
        );
      } else {
        deliveryDate = this.formatDate2(new Date());
      }

      if (!this.isSourceInspectionView || this.$props.isSourcePrescription) {
        returnItems = {
          patientCode: this.patient,
          patientName: this.patientNam,
          deliveryDate: deliveryDate,
          insertFlag: this.$props.isSourcePrescription,
          productDetail: [],
        };
      } else {
        returnItems = [];
      }
      // 器機分ループ
      for (var item in this.productDispoables) {
        for (var index in this.productDispoables[item].disposables) {
          var target = this.productDispoables[item].disposables[index];

          this.backupProductDispoables.find((product) => {
            if (product.serialNumber == this.productDispoables[item].serialNumber) {
              let backup = product.disposables.find((data) => data.itemCode == target.itemCode);
              if (backup && backup.nextDate && target.nextDate != backup.nextDate) {
                target.oldDeliveryMonth = backup.nextDate;
              }
            }
          })

          if (target.regularDeliveryFlag) {
            continue;
          }
          target.regularDeliveryFlag = false;
        }
        var rtnObj = {
          productCode: this.productDispoables[item].productCode,
          productName: this.productDispoables[item].productName,
          serialNumber: this.productDispoables[item].serialNumber,
          shoumouList: [],
        };
        var onTeikiShoumou = this.productDispoables[item].disposables.filter(
          (v) => v.itemCode && v.deliveryKindFlag == 1
        );
        var notTeikiShoumou = this.productDispoables[item].disposables.filter(
          (v) => v.itemCode && v.deliveryKindFlag != 1
        );
        for (var item1 in onTeikiShoumou) {
          rtnObj.shoumouList.push(onTeikiShoumou[item1]);
        }

        for (var item2 in notTeikiShoumou) {
          rtnObj.shoumouList.push(notTeikiShoumou[item2]);
        }

        if (!this.isSourceInspectionView || this.$props.isSourcePrescription) {
          returnItems.productDetail.push(rtnObj);
        } else {
          returnItems.push(rtnObj);
        }
      }
      return returnItems;
    },
    getFieldName: function (type, name, serial, index) {
      return type + name + serial + index;
    },
    getDeliveryName: function (value) {
      var deliveryElement = this.disposablesMaster.find(
        (v) => v.productCode === value
      );
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    },
    getProductName: function (value) {
      var deliveryElement = this.productMaster.find(
        (v) => v.productCode === value
      );
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    },
    filteredDeliveryList: function (inputValue) {
      //選択候補を絞り込む
      this.filteredProduct = this.disposablesMaster.filter((option) => {
        var retValue =
          option.key
            .toString()
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) >= 0;
        return retValue;
      });
      //未選択用の選択肢を追加する
      this.filteredProduct.unshift({
        key: "　",
        productCode: "",
        productName: "",
      });
    },
    filteredProductList: function (inputValue) {
      //選択候補を絞り込む
      this.filteredProduct = this.productMaster.filter((option) => {
        var retValue =
          option.key
            .toString()
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) >= 0;
        return retValue;
      });
      //未選択用の選択肢を追加する
      this.filteredProduct.unshift({
        key: "　",
        productCode: "",
        productName: "",
      });
    },
    setDateNull: function (disposable) {
      // 前回供給日(次回供給予定日)のクリア処理(消耗品[8~10])
      disposable.preDate = null;
      disposable.nextDate = null;
    },
    setNextDate: function (disposable) {
      // 前回供給日⇒次回供給予定日 の自動計算、設定処理(消耗品[8~10])
      if (disposable.preDate) {
        var interval = disposable.interval;
        var year = parseInt(interval / 12);
        var month = parseInt(interval % 12);
        var targetDate =
          typeof disposable.preDate == "string"
            ? this.parseDate(disposable.preDate)
            : disposable.preDate;
        disposable.preDate = targetDate;
        disposable.preDateSt = this.formatDate2(targetDate);
        //対象月(前回供給日+期間)の月初日
        var targetFirstDay = new Date(
          Number(targetDate.getFullYear() + year),
          Number(targetDate.getMonth() + month),
          1
        );
        var targetLastDay = this.parseDate(
          this.getMonthLastDay(targetFirstDay)
        );
        if (targetLastDay.getDate() >= targetDate.getDate()) {
          // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
          // そのまま設定
          var next1InspectionDate = new Date(
            Number(targetDate.getFullYear()) + year,
            Number(targetDate.getMonth()) + month,
            targetDate.getDate()
          );
        } else {
          // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
          // 対象月の月末日を設定
          next1InspectionDate = targetLastDay;
        }
        disposable.nextDate = this.formatDate2(next1InspectionDate);
      }
    },
    setInterval: function (newPreDate, disposable) {
      // 前回供給日から発送期間を自動計算
      if (newPreDate) {
        const start = dayjs(newPreDate).startOf("month");
        const end = dayjs(disposable.nextDate).startOf("month");
        const diffMonth = end.diff(start, "month");

        if (diffMonth > 0 && disposable.interval != diffMonth) {
          disposable.interval = diffMonth;
          disposable.preDate = new Date(newPreDate);
        }
      }
    },
    setPreDate: function (newInterval, disposable) {
      // 発送期間から前回供給日を自動計算
      if (newInterval) {
        const newPreDate = dayjs(disposable.nextDate).subtract(Number(newInterval), "month");
        const oldPreDate = dayjs(disposable.preDate).format("YYYY/MM/DD");

        if (oldPreDate != newPreDate.format("YYYY/MM/DD")) {
          disposable.interval = newInterval;
          disposable.preDate = new Date(newPreDate);
        }
      }
    },
    getNextDate: function (preDate, interval, charFlag) {
      // 前回供給日⇒次回供給予定日の自動計算
      var year = parseInt(interval / 12);
      var month = parseInt(interval % 12);
      var next1InspectionDate;
      //対象月(前回供給日+期間)の月初日
      var targetFirstDay = new Date(
        Number(preDate.getFullYear() + year),
        Number(preDate.getMonth() + month),
        1
      );
      var targetLastDay = this.parseDate(this.getMonthLastDay(targetFirstDay));
      if (targetLastDay.getDate() >= preDate.getDate()) {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
        // そのまま設定
        next1InspectionDate = new Date(
          Number(preDate.getFullYear()) + year,
          Number(preDate.getMonth()) + month,
          preDate.getDate()
        );
      } else {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
        // 対象月の月末日を設定
        next1InspectionDate = targetLastDay;
      }
      if (charFlag) {
        return this.formatDate2(next1InspectionDate);
      }
      return next1InspectionDate;
    },
    getPreDate: function (nextDate, interval) {
      // 指定納期⇒前回供給日の自動計算
      var preDate;
      var year = parseInt(interval / 12);
      var month = parseInt(interval % 12);
      var targetFirstDay = new Date(
        Number(nextDate.getFullYear()) - year,
        Number(nextDate.getMonth()) - month,
        1
      );
      var targetLastDay = this.parseDate(
        this.getMonthLastDay(targetFirstDay)
      ).getDate();
      if (targetLastDay >= nextDate.getDate()) {
        // 対象月(次回供給日-期間)の月末日が次回供給予定の日以上
        // そのまま設定
        preDate = new Date(
          Number(nextDate.getFullYear()) - year,
          Number(nextDate.getMonth()) - month,
          nextDate.getDate()
        );
      } else {
        // 対象月(次回供給日-期間)の月末日が次回供給予定の日より小さい
        // 対象月の月末日を設定
        preDate = new Date(
          Number(nextDate.getFullYear()) - year,
          Number(nextDate.getMonth()) - month,
          targetLastDay
        );
      }
      return this.formatDate2(preDate);
    },
    checkDisposablesOrder() {
      var rtnFlg = true;
      grid_loop: for (var item in this.productDispoables) {
        // if (this.productDispoables[item].disposables[0].interval <= 1) {
        for (
          var i = 0;
          i < this.productDispoables[item].disposables.length;
          i++
        ) {
          if (
            this.productDispoables[item].disposables[i].itemCode &&
            !this.productDispoables[item].disposables[i].deleteFlg &&
            this.productDispoables[item].disposables[i].regularDeliveryFlag &&
            this.productDispoables[item].disposables[i].interval <= 1
          ) {
            // 未削除かつ、発送フラグがTrueかつ、点検期間が「1」以下の場合
            rtnFlg = false;
            break grid_loop;
          }
        }
        // }
      }
      return rtnFlg;
    },
    getProductDispoables() {
      return this.productDispoables;
    },
    isChancelDisabled(disposable) {
      return (
        this.isCancelActive ||
        !disposable.regularDeliveryFlag ||
        disposable.cancelDownloadFlag
      );
    },
    disposableFilter: function (value, disposablesMaster) {
      var product = disposablesMaster.find(
        (v) => v.productCode === value.itemCode
      );
      if (product) {
        return (value.name =
          product.productName + " (" + product.productCode + ")");
      }
      return (value.name = "");
    },
    setProductName: function (productCode, disposablesMaster) {
      var product = disposablesMaster.find(
        (v) => v.productCode === productCode
      );
      if (product) {
        return product.productName + " (" + product.productCode + ")";
      }
      return "";
    },
    addListPush: function (product) {
      let interval;
      let itemPreDate;
      let itemNextDate;
      if (this.isSourceInspection) {
        // 遷移元: 点検、または処方値変更
        interval = this.intervalMonth;
        itemPreDate = this.itemPreDate;
        itemNextDate = this.itemNextDate;
      } else {
        // 遷移元: 消耗品発送
        interval = product.interval;
        const nextMonth = dayjs(product.nextDate).format("YYYY/MM");
        if (nextMonth == this.searchDeliveryMonth) {
          // 発送履歴作成済
          itemPreDate = product.preDate;
          itemNextDate = product.nextDate;
        } else {
          // 発送履歴未作成（点検日、点検期間から求めた見做し）
          const nextDay = dayjs(product.nextDate).format("DD");
          const searchDeliveryMonthLastDate = dayjs(this.searchDeliveryMonth + "/01").endOf("month");
          if (nextDay == dayjs(product.nextDate).endOf("month").format("DD") &&
            nextDay > searchDeliveryMonthLastDate.format("DD")
          ) {
            // 月末日切り詰め
            itemNextDate = searchDeliveryMonthLastDate.format("YYYY/MM/DD");
          } else {
            itemNextDate = this.$props.searchDeliveryMonth + "/" + nextDay;
          }

          itemPreDate = this.getPreDate(new Date(itemNextDate), product.interval);
        }
      }

      var insObj = {
        interval: Number(interval),
        preDate:
          typeof itemPreDate == "string"
            ? this.parseDate(itemPreDate)
            : itemPreDate,
        preDateSt:
          typeof itemPreDate == "string"
            ? itemPreDate
            : this.formatDate2(itemPreDate),
        nextDate: itemNextDate,
        regularDeliveryFlag: false,
        cancelFlag: false,
        count: 0,
        addFlg: true,
      };

      if (
        (!this.isSourceInspectionView && !this.isCancelActive) ||
        (this.isSourceInspectionView && !this.activeFlag)
      ) {
        insObj.deliveryKindFlag = 9;
      }
      product.disposables.push(insObj);
    },
    changeDeliveryKindFlag: function (
      name,
      subscript,
      index,
      deliveryKindFlag
    ) {
      this.$validator.errors.remove(name);

      //リストボックスの非定期から定期に切り替えで必要、前回点検日を再設定する
      var date =
        typeof this.itemPreDate == "string"
          ? this.itemPreDate
          : this.formatDate2(this.itemPreDate);
      this.productDispoables[subscript].disposables[index]["preDateSt"] = date;
      this.productDispoables[subscript].disposables[index]["preDate"] = this.parseDate(date);

      //リストボックスの非定期から定期に切り替えで必要、期間を再設定する
      this.productDispoables[subscript].disposables[index]["interval"] =
        this.intervalMonth;

      //リストボックスの非定期から定期に切り替えで必要、次回供給予定日を再設定する
      if (deliveryKindFlag == 1) {
        var disposable = this.productDispoables[subscript].disposables[index];
        var interval = disposable.interval;
        var year = parseInt(interval / 12);
        var month = parseInt(interval % 12);
        var targetDate =
          typeof disposable.preDateSt == "string"
            ? this.parseDate(disposable.preDateSt)
            : disposable.preDateSt;
        var targetFirstDay = new Date(
          Number(targetDate.getFullYear() + year),
          Number(targetDate.getMonth() + month),
          1
        );
        var targetLastDay = this.parseDate(
          this.getMonthLastDay(targetFirstDay)
        );

        //月によって末日が違うので場合によって計算方法を変える
        if (targetLastDay.getDate() >= targetDate.getDate()) {
          // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
          // そのまま設定
          var next1InspectionDate = new Date(
            Number(targetDate.getFullYear()) + year,
            Number(targetDate.getMonth()) + month,
            targetDate.getDate()
          );
        } else {
          // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
          // 対象月の月末日を設定
          next1InspectionDate = targetLastDay;
        }

        //設定する
        this.productDispoables[subscript].disposables[index]["nextDate"] =
          this.formatDate2(next1InspectionDate);
      }

      if (!this.isSourceInspectionView) {
        //指定納期が変更されていた際の処理
        if (this.designatedDeliveryDate) {
          this.productDispoables[subscript].disposables[index].nextDate =
            this.formatDate2(this.designatedDeliveryDate);

          var setPredate = this.getPreDate(
            this.designatedDeliveryDate,
            this.productDispoables[subscript].disposables[index].interval
          );

          //リストボックスが定期場合の前回供給日表示用(preDateSt)
          this.productDispoables[subscript].disposables[index].preDateSt =
            setPredate;

          this.productDispoables[subscript].disposables[index].preDate =
            this.parseDate(setPredate);
        }
      }
    },
    deleteDisposable: function (product, index) {
      const disposables = product.disposables;
      // 削除
      disposables[index].deleteFlg = true;
      disposables.splice(index, 1, disposables[index]);
      // 初期値の行
      const shoumouList = disposables.filter((item) => !item.deleteFlg)
      if (shoumouList.length == 0) {
        this.addListPush(product);
      }
      return;
    },
  },
  data() {
    var disposablesMaster = [];
    this.getDeliveryList(disposablesMaster);
    var productMaster = [];
    this.getProductList(productMaster);
    // 発送フラグ
    var isDeliveryActive = false;
    // キャンセルフラグ
    var isCancelActive = false;
    // キャンセル表示フラグ
    var isCancelDisplay = false;
    //品目コードフラグ
    var isProductCodeActive = false;
    // 個数フラグ
    var isCountActive = false;
    // 指定納期フラグ
    var isDesignatedDeliveryDateActive = false;

    // 遷移元からのパラメータ取得
    var disposableItems = this.$props.disposablesByDevice;
    var isSourceInspectionView = this.$props.isSourceInspection;
    var patient = this.$props.patientCode;
    var patientNam = this.$props.patientName;
    var intervalMonth = this.$props.interval;
    var name = this.$props.productName;
    var serial = this.$props.serialNumber;
    var activeFlag = true;
    var statusFlag = false;
    var allDisableFlag = false;
    if (this.$props.isActive != undefined) {
      activeFlag = this.$props.isActive;
    }
    var notChangeFlag = false;
    if (this.$props.inspectionFlg != undefined) {
      notChangeFlag = this.$props.inspectionFlg;
    }

    if (disposableItems[0].statusFlag != undefined) {
      statusFlag = disposableItems[0].statusFlag == 1;
    }
    if (!isSourceInspectionView && this.$props.disabledFlag != undefined) {
      allDisableFlag = this.$props.disabledFlag;
    }
    var productDispoables = [];
    var targetDate = "9999/99/99";
    // 機器数分のループ(遷移元パラメータ)
    var itemList = [];
    let disposableItemsPreDate;
    for (var item in disposableItems) {
      if (disposableItems[item].shoumouList.length > 0) {
        var firstDataPreDate = disposableItems[item].shoumouList[0].preDate;
        var firstDataNextDate = disposableItems[item].shoumouList[0].nextDate;
        var firstDataInterval = disposableItems[item].shoumouList[0].interval;
        for (const shoumou of disposableItems[item].shoumouList) {
          if (shoumou.nextDate < targetDate) {
            targetDate = shoumou.nextDate;
          }
        }
      }
      if (!isSourceInspectionView && disposableItems[item].shoumouList.length == 0) {
        var firstDataPreDate = disposableItems[item].preDate;
        var firstDataNextDate = disposableItems[item].nextDate;
        var firstDataInterval = disposableItems[item].interval;
      }
      var setDispoables = {
        productCode: disposableItems[item].productCode,
        productName: disposableItems[item].productName,
        serialNumber: disposableItems[item].serialNumber,
        inspectionKind: disposableItems[item].inspectionKind
          ? disposableItems[item].inspectionKind
          : null,
        disposables: [],
        isInspectionMonth: disposableItems[item].isInspectionMonth,
        preDate: disposableItems[item].preDate,
        nextDate: disposableItems[item].nextDate,
        interval: disposableItems[item].interval,
      };
      var shomouItem = disposableItems[item].shoumouList;
      var disposableList = [];

      for (var index in shomouItem) {
        // 消耗品リスト作成
        if (isSourceInspectionView) {
          if (this.$props.isSourcePrescription) {
            // 処方値修正画面から(初回定期消耗品発送登録)
            var preDate;
            var nextDate;
            preDate =
              shomouItem[index].deliveryKindFlag == 1
                ? this.$props.previousDate
                : shomouItem[index].preDate;
            nextDate =
              shomouItem[index].deliveryKindFlag == 1
                ? this.getNextDate(
                    this.parseDate(this.$props.previousDate),
                    intervalMonth,
                    true
                  )
                : shomouItem[index].nextDate;
          } else {
            // 点検入力画面から
            // 画面再遷移の為に、日付を強制的に文字列として扱う
            var workDate =
              typeof shomouItem[index].preDate == "string"
                ? shomouItem[index].preDate
                : this.formatDate2(shomouItem[index].preDate);
            preDate =
              shomouItem[index].deliveryKindFlag == 1
                ? this.formatDate2(new Date())
                : this.parseDate(workDate);
            nextDate =
              shomouItem[index].deliveryKindFlag == 1
                ? this.getNextDate(new Date(), intervalMonth, true)
                : shomouItem[index].nextDate;
          }
          // 遷移元が点検画面の場合
          shomouItem[index].interval =
            shomouItem[index].deliveryKindFlag == 1
              ? intervalMonth
              : shomouItem[index].interval;
          shomouItem[index].preDate =
            typeof preDate == "string" ? this.parseDate(preDate) : preDate;
          shomouItem[index].preDateSt =
            typeof preDate == "string" ? preDate : this.formatDate2(preDate);
          shomouItem[index].nextDate = nextDate;
          disposableList.push(shomouItem[index]);
        } else {
          setDispoables.newestFlag = disposableItems[item].newestFlag;
          // 遷移元が検索画面の場合
          if (disposableItems[item].deliveryKindFlag == 1) {
            // 定期消耗品の場合
            if (shomouItem[index].preDate != null) {
              disposableItemsPreDate = shomouItem[index].preDate;
            } else {
              disposableItemsPreDate = firstDataPreDate;
            }
          } else {
            // 非定期の場合
            disposableItemsPreDate = 
            typeof shomouItem[index].preDate == "string" ? this.parseDate(shomouItem[index].preDate) : shomouItem[index].preDate;
          }
          shomouItem[index].preDate = disposableItemsPreDate;
          shomouItem[index].preDateSt = this.formatDate2(
            disposableItemsPreDate
          );
          shomouItem[index].nextDate =
            shomouItem[index].nextDate != null ||
            shomouItem[index].deliveryKindFlag != 1
              ? shomouItem[index].nextDate
              : firstDataNextDate;
          disposableList.push(shomouItem[index]);
        }
      }
      setDispoables.disposables = disposableList;
      productDispoables.push(setDispoables);
    }

    // 共通項目の設定
    var itemPreDate;
    var itemNextDate;
    if (isSourceInspectionView) {
      if (this.$props.isSourcePrescription) {
        // 処方値修正画面から(初回定期消耗品発送登録)
        itemPreDate = this.$props.previousDate;
        itemNextDate = this.getNextDate(
          this.parseDate(this.$props.previousDate),
          intervalMonth,
          true
        );
      } else {
        // 点検入力画面から
        itemPreDate = this.formatDate2(new Date());
        itemNextDate = this.getNextDate(new Date(), intervalMonth, true);
      }
    } else {
      // 遷移元が検索画面の場合
      intervalMonth = firstDataInterval;
      if (productDispoables[0].disposables.length == 0) {
        // 月末日処理
        const nextDay = dayjs(firstDataNextDate).format("DD");
        const searchDeliveryMonthLastDate = dayjs(this.$props.searchDeliveryMonth + "/01").endOf("month");
        let nextDate;
        if (nextDay == dayjs(firstDataNextDate).endOf("month").format("DD") &&
          nextDay > searchDeliveryMonthLastDate.format("DD")
        ) {
          nextDate = searchDeliveryMonthLastDate.format("YYYY/MM/DD");
        } else {
          nextDate = this.$props.searchDeliveryMonth + "/" + nextDay;
        }

        itemPreDate = this.getPreDate(new Date(nextDate), intervalMonth);
        itemNextDate = nextDate;
      } else {
        itemPreDate = firstDataPreDate;
        itemNextDate = firstDataNextDate;
      }
    }

    var minDate = null;
    var maxDate = null;
    var now = new Date();
    var today = now.getDate();
    if (!isSourceInspectionView && targetDate != null) {
      // 検索画面から遷移した場合

      targetDate = new Date(this.$props.searchDeliveryMonth + "/01");

      minDate = targetDate;
      maxDate = dayjs(targetDate).endOf("month").toDate();

      // 次回供給予定日判定処理
      var nextMonth = now.getMonth() + 2;
      if (nextMonth > 12) {
        nextMonth = parseInt(nextMonth / 12);
      }
      var today = now.getDate();
      const lastCancelDay = this.getShoumouCancelRangeEndDay();
      var targetMonth = targetDate.getMonth() + 1;

      // 次回供給予定日が2か月以上先 OR 次月
      if (targetMonth == nextMonth) {
        // 次回供給予定日が次月の場合
        if (5 >= today) {
          // 1-5日
          isDeliveryActive = false;
          isCancelDisplay = false;
          isCancelActive = true;
          isProductCodeActive = false;
          isCountActive = false;
          isDesignatedDeliveryDateActive = false;
        } else if (5 < today && today <= lastCancelDay) {
          // 6日以降 かつ、キャンセル可能期間
          isDeliveryActive = true;
          isCancelDisplay = true;
          isCancelActive = false;
          isProductCodeActive = true;
          isCountActive = true;
          isDesignatedDeliveryDateActive = true;
        } else if (5 < today && today > lastCancelDay) {
          // 6日以降 かつ、キャンセル可能期間超過
          isDeliveryActive = true;
          isCancelDisplay = true;
          isCancelActive = true;
          isProductCodeActive = true;
          isCountActive = true;
          isDesignatedDeliveryDateActive = true;
        }
      } else {
        // 次回供給予定日が次月でない場合
        isDeliveryActive = false;
        isCancelDisplay = false;
        isCancelActive = true;
        isProductCodeActive = false;
        isCountActive = false;
        isDesignatedDeliveryDateActive = false;
      }
    }

    // 次回確定日
    let nextConfirmedDate;
    if (today <= 5) {
      // 今月5日
      nextConfirmedDate = new Date(now.getFullYear(), now.getMonth(), 5).getTime();
    } else {
      // 翌月5日
      nextConfirmedDate = new Date(now.getFullYear(), now.getMonth() + 1, 5).getTime();
    }

    let isNotAdd = false;
    if (this.$props.searchDeliveryMonth) {
      let confirmedDate = new Date(this.$props.searchDeliveryMonth + "/05").getTime();
      if (now.getTime() > confirmedDate) {
        isNotAdd = true;
      }
    }

    return {
      isSourceInspectionView,
      patient,
      patientNam,
      intervalMonth,
      productDispoables,
      disposablesMaster,
      productMaster,
      filteredProduct: [],
      designatedDeliveryDate: null,
      minDate,
      maxDate,
      isDeliveryActive,
      isCancelActive,
      isCancelDisplay,
      isProductCodeActive,
      isCountActive,
      isDesignatedDeliveryDateActive,
      successEndFlg: false,
      isDuplicationError: false,
      searchProductCode: "",
      isSelectProductActive: false,
      targetItem: {
        productCode: "",
        productName: "",
        serialNumber: "",
        index: null,
        deliveryKindFlag: null,
      },
      activeFlag,
      itemPreDate,
      itemNextDate,
      notChangeFlag,
      statusFlag,
      allDisableFlag,
      nextConfirmedDate,
      backupProductDispoables: null,
      isNotAdd,
      designatedDeliveryDateFocuse: new Date(this.searchDeliveryMonth),
    };
  },
  mounted: function () {
    //患者動態消耗に品目が登録されてない場合、画面に1項目追加する
    if (
      this.productDispoables[0].disposables &&
      this.productDispoables[0].disposables.length == 0
    ) {
      this.addListPush(this.productDispoables[0]);
    }

    this.backupProductDispoables = JSON.parse(JSON.stringify(this.productDispoables));

    return;
  },
  components: { "selectProduct-form": selectProductform },
  computed: {},
  watch: {
    disposablesMaster: function (val) {
      for (var item in this.productDispoables) {
        var target = this.productDispoables[item].disposables;
        for (var i = 0; i < target.length; i++) {
          if (target[i].deliveryKindFlag != 1) {
            continue;
          }
          target[i].name = this.setProductName(target[i].itemCode, val);
        }
      }
    },
    productMaster: function (val) {
      for (var item in this.productDispoables) {
        var target = this.productDispoables[item].disposables;
        for (var i = 0; i < target.length; i++) {
          if (target[i].deliveryKindFlag == 1) {
            continue;
          }
          target[i].name = this.setProductName(target[i].itemCode, val);
        }
      }
    },
    designatedDeliveryDate: function (val) {
      // 次回供給日設定処理
      if (val != null) {
        // 指定納期が null でない場合
        var date = this.formatDate2(val);
        for (var item in this.productDispoables) {
          for (var i = 0; i < this.productDispoables[item].disposables.length; i++) {
            this.productDispoables[item].disposables[i].nextDate = date;
            this.productDispoables[item].disposables[i].preDateSt =
              this.getPreDate(
                val,
                this.productDispoables[item].disposables[i].interval
              );
            this.productDispoables[item].disposables[i].preDate =
              this.parseDate(
                this.productDispoables[item].disposables[i].preDateSt
              );
          }
        }
      }
    },
  },
  created: function () {
    this.$validator.extend("checkDisposable", {
      getMessage: (field) => `入力された消耗品コードは存在しません。`,
      validate: (value) => {
        var ret = true;
        // 入力値チェック
        if (this.getDeliveryName(value) == "") {
          var ret = false;
        }
        return ret;
      },
    });
    this.$validator.extend("checkProduct", {
      getMessage: (field) => `入力された消耗品コードは存在しません。`,
      validate: (value) => {
        var ret = true;
        // 入力値チェック
        if (this.getProductName(value) == "") {
          var ret = false;
        }
        return ret;
      },
    });
    this.$validator.extend("checkInterval", {
      getMessage: (field) =>
        `発送期間が「1」の場合、発送として登録できません。`,
      validate: (value, interval) => {
        var ret = true;
        // 入力値チェック
        if (interval[0] == 1 && value) {
          var ret = false;
        }
        return ret;
      },
    });
    this.$validator.extend("checkDuplication", {
      getMessage: (field) => `消耗品コードが重複しています。`,
      validate: (value, list) => {
        var ret = true;
        // 入力値チェック
        var code = list[0];
        var serial = list[1];
        var data = this.getProductDispoables();
        // 対象の消耗品リストを取得
        var targetList = data.find(
          (val) => val.productCode === code && val.serialNumber === serial
        );
        // 対象の消耗品リスト[発送対象]のうち、同一品目コードを取得
        var disposableList = targetList.disposables.filter(
          (v) => v.itemCode == value && !v.deleteFlg
        );
        if (disposableList.length > 1) {
          var ret = false;
        }
        return ret;
      },
    });

    this.$validator.extend("checkNextDate", {
      getMessage: (field) =>
        `非定期消耗品は点検当日から3ヶ月以降でないと登録できません。`,
      validate: (value, data) => {
        var ret = true;
        const productIndex = data[0];
        const shoumouIndex = data[1];
        const oldNextDate = this.backupProductDispoables[productIndex].disposables[shoumouIndex] ?
          dayjs(this.backupProductDispoables[productIndex].disposables[shoumouIndex].nextDate).format("YYYYMMDD") :
          null;
        const newShoumou = this.productDispoables[productIndex].disposables[shoumouIndex];
        const newNextDate = newShoumou.nextDate;
        const deliveryKindFlag = newShoumou.deliveryKindFlag;

        if (!newShoumou.itemCode || oldNextDate == dayjs(newNextDate).format("YYYYMMDD")) {
          return ret;
        }

        if (this.isSourceInspectionView && !this.$props.isSourcePrescription) {
          // 点検入力画面からの場合
          // 点検当日から3ヶ月後
          const later3Month = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 3,
            1
          ).getTime();
          const nextMonth = new Date(
            new Date(newNextDate).getFullYear(),
            new Date(newNextDate).getMonth(),
            1
          ).getTime();
          if (deliveryKindFlag != 1 && nextMonth < later3Month) {
            ret = false;
          }
        }

        return ret;
      },
    });

    this.$validator.extend("checkConfirmedDate", {
      getMessage: (field) =>
        `次回発送月の確定可能期間を過ぎています。`,
      validate: (value, data) => {
        var ret = true;
        const productIndex = data[0];
        const shoumouIndex = data[1];
        const oldShoumou = this.backupProductDispoables[productIndex].disposables[shoumouIndex];
        const oldNextDate =  oldShoumou ? dayjs(oldShoumou.nextDate).format("YYYYMMDD") : null;
        const newShoumou = this.productDispoables[productIndex].disposables[shoumouIndex];
        const newNextDate = newShoumou.nextDate;
        const oldRegularDeliveryFlag = oldShoumou ? oldShoumou.regularDeliveryFlag : false;
        const newRegularDeliveryFlag = newShoumou.regularDeliveryFlag;

        if (
          oldShoumou &&
          // 処方値修正/点検入力画面
          this.isSourceInspectionView &&
          // 消耗品種別、品目、サイクル、個数、次回発送日の変更なし
          oldShoumou.deliveryKindFlag == newShoumou.deliveryKindFlag &&
          oldShoumou.itemCode == newShoumou.itemCode &&
          oldShoumou.interval == newShoumou.interval &&
          oldShoumou.count == newShoumou.count &&
          oldNextDate == dayjs(newNextDate).format("YYYYMMDD") &&
          // 発送なし→あり以外はチェック不要
          (!newRegularDeliveryFlag ||
            (oldRegularDeliveryFlag && newRegularDeliveryFlag))
        ) {
          return ret;
        }

        if (
          !newShoumou.itemCode ||
          newShoumou.deliveryKindFlag == 1 ||
          (this.isSourceInspectionView && this.$props.isSourcePrescription && !this.$props.inspectionFlg) // 処方値修正画面かつ未点検
        ) {
          return ret;
        }

        // 次回発送月の確定日(前月5日)
        const nextDate = new Date(newNextDate);
        const confirmedDate = new Date(
          nextDate.getFullYear(),
          nextDate.getMonth() - 1,
          5
        ).getTime();

        if (confirmedDate < this.nextConfirmedDate) {
          ret = false;
        }

        return ret;
      },
    });

    this.$validator.extend("checkNextInspection", {
      getMessage: (field) =>
        `次回点検予定月より先の明細に定期消耗品追加はできません。`,
      validate: (value, data) => {
        var ret = true;

        // 処方値修正画面かつ未点検
        if (this.isSourceInspectionView && this.$props.isSourcePrescription && !this.$props.inspectionFlg ) {
          return ret;
        }

        if (this.isSourceInspectionView){
          // 処方値修正、点検入力画面からの場合
          if(
            data[2] && // itemCode
            data[0] == 1 && // deliveryKindFlag
            new Date(data[1]).getTime() > this.getNextDate(new Date(), this.intervalMonth, false).getTime() // nextDate
          ) {
            ret = false;
          }
        }

        return ret;
      },
    });
  },
};
</script>
<style lang="scss">
.autocomplete > .dropdown-menu > .dropdown-content {
  width: 500px;
}
.notice {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #209cee;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/AppRegularDisposablesOrder.vue